/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Real_Tough_Kestrel_SeekInputs */

const fr_real_tough_kestrel_seek = /** @type {(inputs: Real_Tough_Kestrel_SeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration du programme hebdomadaire`)
};

/**

* @param {Real_Tough_Kestrel_SeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const real_tough_kestrel_seek = /** @type {((inputs?: Real_Tough_Kestrel_SeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Real_Tough_Kestrel_SeekInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_real_tough_kestrel_seek(inputs)
});